import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import Modal from "../../../../../components/common/Modal";
import PrimaryButton, {
  PrimaryButtonType,
} from "../../../../../components/common/PrimaryButton";
import OutlinedButton from "../../../../../components/common/OutlinedButton";
import Spinner from "../../../../../components/common/Spinner";

interface IConfirmModalProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  danger?: boolean;
  saving?: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
}

/**
 * Shared confirmation step for the three cashout-bank actions that change where money goes or
 * destroy a record: activate, deactivate and delete.
 */
const ConfirmModal = ({
  open,
  title,
  message,
  confirmLabel,
  danger = false,
  saving = false,
  handleClose,
  handleConfirm,
}: IConfirmModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      visible={open}
      onCancel={handleClose}
      customModalClassName={styles.modal}>
      <div className={styles.container}>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.subtitle}>{message}</p>

        <div className={styles.actions}>
          <PrimaryButton
            buttonType={
              danger ? PrimaryButtonType.DANGER : PrimaryButtonType.DEFAULT
            }
            disabled={saving}
            onClick={handleConfirm}>
            {saving ? <Spinner /> : confirmLabel}
          </PrimaryButton>
          <OutlinedButton disabled={saving} onClick={handleClose}>
            {t("lbl_cancel")}
          </OutlinedButton>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
